class BaoMoreInPrintCarousel extends window.BAO.Carousel.Element {
  static get requiredElements () {
    return super.requiredElements.concat(['previous', 'next'])
  }

  initialiseCarousel () {
    if (this.els.slide.elements.length <= 1) return null

    const perView = Number(this.dataset.slidesPerView) || 1.35
    const previous = this.els.previous.element
    const next = this.els.next.element

    return new window.KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        defaultAnimation: {
          duration: 1500,
        },
        loop: false,
        mode: 'snap',
        rubberband: false,
        slides: {
          perView,
          spacing: 0,
        },
      },
      [
        window.BAO.Carousel.useInitialised(),
        window.BAO.Carousel.useArrows({ previous, next }),
        carousel => {
          const syncArrowVisibility = () => {
            if (!carousel?.track?.details) return

            const { abs, maxIdx, min } = carousel.track.details

            if (previous) {
              previous.disabled = abs <= min
            }

            if (next) {
              next.disabled = abs >= maxIdx
            }
          }

          carousel.on('created', syncArrowVisibility)
          carousel.on('slideChanged', syncArrowVisibility)
          carousel.on('animationEnded', syncArrowVisibility)
          carousel.on('updated', syncArrowVisibility)
        },
      ],
    )
  }

  afterInitialiseCarousel () {
    this.listeners.add(this, 'click', this.trackCarouselClick.bind(this))
    this.trackCarouselView()
  }

  trackCarouselView () {
    const observer = new IntersectionObserver((entries) => {
      // eslint-disable-next-line shopify/prefer-early-return
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          window.BAO.Utils.pushToDataLayer('more_in_print_viewed')

          observer.unobserve(entry.target)
        }
      })
    }, { threshold: 0 })

    observer.observe(this)
  }

  trackCarouselClick (event) {
    const productCard = event.target.closest('product-card')

    if (!productCard) return

    const parameters = {
      item_title: productCard.getAttribute('data-product-title') || '',
    }

    if (!event.target.closest('quick-add-opener')) {
      window.BAO.Utils.pushToDataLayer('more_in_print_card_click', parameters)
    }
  }
}

if (!customElements.get('bao-more-in-print-carousel')) {
  customElements.define('bao-more-in-print-carousel', BaoMoreInPrintCarousel)
}
